/* Studio Amac / Freedom of Flight: interactive pricing and secure Formspree submission */
(function () {
  function mount() {
    const root = document.getElementById('fof-root');
    if (!root || root.dataset.fofMounted === 'true') return;
    root.dataset.fofMounted = 'true';
    const endpoint = root.dataset.formspreeEndpoint || '';
    const enabled = root.dataset.submissionsEnabled === 'true';
    const cards = {
      '3.5x5': {250:550,500:850,1000:1250,2000:2000},
      '4.25x5.5': {250:625,500:1000,1000:1500,2000:2500},
      '5x7': {250:750,500:1250,1000:2000,2000:3500}
    };
    const stickerPrices={100:225,200:420,300:600,400:760,500:900,750:1275,1000:1600,2000:3000};
    const nfcPrices={250:312.5,500:500,1000:850,2000:1500};
    const el=(id)=>root.querySelector('#'+id);
    const val=(id)=>(el(id)?.value||'').trim();
    const radio=(name)=>root.querySelector('input[name="'+name+'"]:checked')?.value||'';
    const usd=(amount)=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(amount);
    function quote(){
      const selected=Array.from(root.querySelectorAll('input[name="cardPackage"]:checked')).map(input=>{
        const [size,count]=input.value.split('|'); return {size,qty:Number(count)};
      });
      const dieQty=Number(val('dieCutQty'))||0,ovalQty=Number(val('ovalQty'))||0;
      const lines=[['Original artwork commission',300],['One-time art card setup',100]];
      let total=400, custom=Boolean(val('cardCustom')||val('stickerCustom'));
      for(const run of selected){
        const price=cards[run.size]?.[run.qty]||0;
        lines.push([run.size+' in art cards × '+run.qty.toLocaleString(),price]);
        total+=price;
      }
      if(val('cardCustom'))lines.push(['Additional custom art-card request: '+val('cardCustom'),'To quote']);
      if(radio('nfc')==='NFC upgrade'){
        for(const run of selected){
          const price=nfcPrices[run.qty]||0;
          lines.push(['NFC upgrade — '+run.size+' in × '+run.qty.toLocaleString(),price]);
          total+=price;
        }
        if(val('cardCustom'))lines.push(['NFC for custom art cards','To quote']);
      }
      if(dieQty){const price=stickerPrices[dieQty]||0;lines.push(['Die-cut stickers × '+dieQty.toLocaleString(),price]);total+=price;}
      if(ovalQty){const price=stickerPrices[ovalQty]||0;lines.push(['Oval stickers × '+ovalQty.toLocaleString(),price]);total+=price;}
      if(val('stickerCustom'))lines.push(['Stickers — custom request: '+val('stickerCustom'),'To quote']);
      if(val('locations').startsWith('Split')||val('shipping').startsWith('Expedited'))custom=true;
      return {selected,dieQty,ovalQty,lines,total,custom};
    }
    function update(){
      el('estimatePreviewNotice').hidden=true;
      el('refOther').classList.toggle('show-ref',radio('reference')==='Different angle/viewpoint');
      const customPhrase=radio('words')==='Other';
      el('wordsOther').classList.toggle('show-writein',customPhrase);
      el('wordsCustom').required=customPhrase;
      el('shippingDetails').classList.toggle('show-shipping',radio('shippingTiming')==='Provide now');
      el('billEntityOther').classList.toggle('show-billing',radio('billingEntity')==='Other entity');
      el('standardDeliveryChoice').hidden=radio('nfc')==='NFC upgrade';
      el('nfcDeliveryNote').hidden=radio('nfc')!=='NFC upgrade';
      const q=quote(),rows=el('estimateRows');rows.replaceChildren();
      for(const [label,price] of q.lines){
        const row=document.createElement('div'),a=document.createElement('span'),b=document.createElement('span');
        row.className='sumline';a.textContent=label;b.textContent=typeof price==='number'?usd(price):price;
        row.append(a,b);rows.append(row);
      }
      el('total').textContent=usd(q.total)+(q.custom?' + items to quote':'');
      el('estimateNote').textContent=q.custom
        ?'USD. This estimate is partial: custom requests need a final quote. Standard shipping is included to one address. Applicable taxes may be additional. No payment is collected here.'
        :'USD. Standard shipping to one U.S. address included; taxes or special requests may be additional. No payment is collected here.';
    }
    const fields=[
      ['Alternative reference details','refUrl'],['Foundation logo link','assetLink'],
      ['Aircraft or artwork specifics','designNotes'],['Custom artwork phrase','wordsCustom'],
      ['Custom card request','cardCustom'],['QR/NFC questions','qrQuestions'],
      ['Die-cut sticker quantity','dieCutQty'],['Oval sticker quantity','ovalQty'],
      ['Custom sticker request','stickerCustom'],['Needed-by date','needBy'],
      ['Shipping service','shipping'],['Delivery locations','locations'],
      ['Recipient','recipient'],['Delivery phone','phone'],['Street address','shipAddr'],
      ['City','shipCity'],['State','shipState'],['Postal code','shipZip'],
      ['Shipping instructions','shipInstructions'],['Billing name','billName'],
      ['Billing email','billEmail'],['Submission/confirmation email','receiptEmail'],
      ['Other billing entity','billEntityName'],['Payment preference','payment'],
      ['Additional notes','finalNotes']
    ];
    function summary(){
      const q=quote();
      const runs=q.selected.length
        ?q.selected.map(r=>r.size+' in / '+r.qty.toLocaleString()+' cards').join('; ')
        :'None selected (custom quote only)';
      const chosenWord=radio('words')==='Other'?val('wordsCustom'):radio('words');
      const billed=radio('billingEntity')==='Other entity'?val('billEntityName'):radio('billingEntity');
      const t=[
        'FREEDOM OF FLIGHT — Studio Amac × JIMMY GRAHAM FOUNDATION',
        'Completed creative brief','',
        'Reference: '+radio('reference'),
        'Artwork color: '+radio('artColor'),
        'Artwork wording: '+chosenWord,
        'Card sizes and quantities: '+runs,
        'NFC: '+radio('nfc'),
        'Card-back connection: '+(radio('nfc')==='NFC upgrade'?'NFC tap-to-open':radio('cardConnectionStandard')),
        'Back-of-card preference: '+radio('mission'),
        'Delivery details: '+radio('shippingTiming'),
        'Die-cut sticker quantity: '+q.dieQty,
        'Oval sticker quantity: '+q.ovalQty,
        'Billed entity: '+billed,
        'Sales tax exemption: '+radio('tax'),
        'Portfolio/social permission: '+radio('portfolio'),
        ''
      ];
      for(const [label,id] of fields)t.push(label+': '+(val(id)||'—'));
      t.push('','PRICING');
      for(const [label,price] of q.lines)t.push(label+': '+(typeof price==='number'?usd(price):price));
      t.push('Estimated subtotal: '+usd(q.total)+(q.custom?' + separately quoted services':''));
      t.push('','Subject to final invoice, proof approval, applicable taxes and additional services.');
      t.push('Standard card credit: Artwork by Studio Amac · studioamac.com');
      return t.join('\n');
    }
    function fail(message,id){
      const status=el('status');status.textContent=message;status.dataset.state='error';
      if(id)el(id)?.focus();return false;
    }
    function validate(){
      if(!root.querySelector('input[name="cardPackage"]:checked')&&!val('cardCustom')){
        return fail('Please select at least one art-card size/quantity or specify a custom request.');
      }
      if(radio('reference')==='Different angle/viewpoint'&&!val('refUrl'))return fail('Please complete: alternative reference details.','refUrl');
      if(radio('words')==='Other'&&!val('wordsCustom'))return fail('Please enter the custom word or phrase.','wordsCustom');
      if(radio('billingEntity')==='Other entity'&&!val('billEntityName'))return fail('Please enter the billing entity.','billEntityName');
      if(!val('billName'))return fail('Please enter a billing contact name.','billName');
      if(!val('billEmail')||!el('billEmail').checkValidity())return fail('Please enter a valid billing email.','billEmail');
      if(val('assetLink')&&!el('assetLink').checkValidity())return fail('Please enter a valid Foundation logo link or leave it blank.','assetLink');
      if(!val('receiptEmail')||!el('receiptEmail').checkValidity())return fail('Please enter a valid email to receive your completed brief.','receiptEmail');
      return true;
    }
    const btn=el('submitBrief');
    const ready=enabled && /^https:\/\/formspree\.io\/f\/[a-zA-Z0-9]+$/.test(endpoint);
    btn.disabled=!ready;btn.setAttribute('aria-disabled',String(!ready));
    if(ready)el('submissionHelp').textContent='Review your selections and submit the completed brief. Studio Amac will email you a copy for your records. No payment is collected through this form.';
    let submitted=false,submitting=false;
    btn.addEventListener('click',async()=>{
      if(!ready||submitted||submitting||!validate())return;
      submitting=true;btn.disabled=true;btn.setAttribute('aria-disabled','true');btn.textContent='Submitting…';
      const status=el('status');status.textContent='Sending your completed brief securely…';status.dataset.state='';
      try{
        const q=quote(),fd=new FormData();
        fd.append('email',val('receiptEmail'));
        fd.append('_subject','Studio Amac — Freedom of Flight completed creative brief');
        fd.append('project','Freedom of Flight / Jimmy Graham Foundation');
        fd.append('brief',summary());
        fd.append('estimated_total_usd',q.total.toFixed(2));
        fd.append('die_cut_stickers',String(q.dieQty));
        fd.append('oval_stickers',String(q.ovalQty));
        fd.append('art_card_selections',q.selected.map(r=>r.size+' inches x '+r.qty).join(' | '));
        fd.append('nfc_upgrade',radio('nfc'));
        fd.append('billing_contact',val('billName'));
        fd.append('billing_email',val('billEmail'));
        const response=await fetch(endpoint,{method:'POST',body:fd,headers:{Accept:'application/json'}});
        if(!response.ok){
          const error=await response.json().catch(()=>({}));
          throw new Error(error.errors?.map(e=>e.message).join(' ')||'Server returned '+response.status);
        }
        submitted=true;
        btn.textContent='Brief submitted';
        status.dataset.state='success';
        status.textContent='Your completed brief was submitted successfully. Studio Amac will email you a copy for your records.';
      }catch(err){
        status.dataset.state='error';
        status.textContent='Your brief was not sent. '+err.message+' Please try again.';
      }finally{
        submitting=false;
        if(!submitted){btn.disabled=false;btn.setAttribute('aria-disabled','false');btn.textContent='Submit completed brief';}
      }
    });
    root.querySelectorAll('input,select,textarea').forEach(item=>{
      item.addEventListener('change',update);
      if(item.tagName==='INPUT'||item.tagName==='TEXTAREA')item.addEventListener('input',update);
    });
    root.querySelectorAll('.price-table tbody tr').forEach(row=>{
      row.addEventListener('click',event=>{
        if(event.target.tagName==='INPUT')return;
        const input=row.querySelector('input[type=checkbox],input[type=radio]');
        if(!input)return;
        input.checked=input.type==='checkbox'?!input.checked:true;
        update();
      });
    });
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);
  else mount();
  document.addEventListener('shopify:section:load',mount);
})();
